module.exports = __webpack_public_path__ + "static/media/jw_green.2b08aa96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bottles/backgrounds/jw_green.png
// module id = 702
// module chunks = 0